import { handleRequest, handleJsonRequest } from '../stories/helpers/httpRequest';
import { getApiBaseUrl } from '../utils';

export default class ApiService {
    language = "";
    province = "";

    insertMockData(year, carline, data) {
        const mockedModels = [...window.mockedModels];
        
        const startsWithAny = mockedModels.some(str => carline.startsWith(str) && year === "2025");

        if (startsWithAny) {
            const mock = require('./financialMock.json');
            Object.assign(data.financial, mock);
        }

        return data;
    }

    constructor() {
    }

    /*
     * Step 1 - Get vehicles
     */
    async getVehicles() {
        const url = `${getApiBaseUrl()}/api/ModelYears?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});

        // FOR MOCK         
        data.data.model_years.forEach(model => {
            this.insertMockData(model.year.url_slug, model.carline.url_slug, model);
        })

        return data.data;
    }

    /*
     * Step 2 - Get trims
     */
    async getTrims(year, carline) {

        const url = `${getApiBaseUrl()}/api/Trims/${year}/${carline}/?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});

        let dataToReturn = data.data;
        // FOR MOCK 
        data.data.trims.forEach(trim => {        
            this.insertMockData(year, carline, trim);
        })

        return dataToReturn;
    }

    /*
     * Step 3 - Get engine and drivetrain
     */
    async getEngineAndDrivetrain(year, carline, trim) {
        const url = `${getApiBaseUrl()}/api/EngineModels/${year}/${carline}/${trim}/?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});
        // FOR MOCK 
        this.insertMockData(year, carline,data.data.trim);

        data.data.models.forEach(model => {
            this.insertMockData(year, carline, model);
        })


        return data.data;
    }

    /*
     * Step 4 - Get packages
     */
    async getPackages(model, option) {

        const url = `${getApiBaseUrl()}/api/Packages/${model}/${option}/?prov_code=${this.province}&lang_code=${this.language}`;

        let data = await handleRequest('get', url, {});

        //Object.assign(data.data, mockProtection);

        return data.data;
    }

    /*
     * Step 5 - Get colours
     */
    async getColours(model, packageCode) {
        const url = `${getApiBaseUrl()}/api/Colors/${model}/${packageCode}?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});
        // FOR MOCK 
        this.insertMockData(data.data.year.url_slug, data.data.carline.url_slug, data.data);

        return data.data;
    }

    /*
     * Step 6 - Get wheels
     */
    async getWheels(model, packageCode) {
        const url = `${getApiBaseUrl()}/api/Wheels/${model}/${packageCode}?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});
        this.insertMockData(data.data.year.url_slug, data.data.carline.url_slug, data.data);        

        return data.data;
    }

    /*
     * Step 7 - Get accessories
     */
    async getAccessories(model, packageCode) {
        const url = `${getApiBaseUrl()}/api/Accessories/${model}/${packageCode}?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});
        this.insertMockData(data.data.year.url_slug, data.data.carline.url_slug, data.data);

        return data.data;
    }

    /*
     * Step 8 - Get payments
     */
    async getPayments(model, packageCode) {
        const url = `${getApiBaseUrl()}/api/Financial/${model}/${packageCode}?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});

        const mockedModels = [...window.mockedModels];
        
        const startsWithAny = mockedModels.some(str => data.data.based_on.model_code.startsWith(str));

        if (startsWithAny) {
            // FOR MOCK
            const mock = require('./financialMock.json');
            Object.assign(data, mock);
        }        


        return data.data;

    }

    /*
     * Step 9 - Get summary
     */
    async getSummary(model, packageCode) {
        const url = `${getApiBaseUrl()}/api/BuildSummaryLegal/${model}/${packageCode}?prov_code=${this.province}&lang_code=${this.language}`;

        const data = await handleRequest('get', url, {});

        return data.data;
    }

    /*
     * Complement Data - Get model specfication data
     */
    async getSpecificationsData(model, optionCode) {
        const url = `${getApiBaseUrl()}/api/specs?lang_code=${this.language}`;

        var fullModelCode = model + "/" + optionCode;
        const requestData = JSON.stringify({ "cars": [fullModelCode] });

        const data = await handleJsonRequest('POST', url, requestData);

        return data.data;

    }

    /*
     * Get build data by build id.
     */
    async getBuildDataById(buildId) {
        const url = `${getApiBaseUrl()}/api/BuildYourMazda/${buildId}`;
        const data = await handleJsonRequest('GET', url, {});
        return data;
    }


    /*
     * Get the dealer data by dealer id.
     */
    async getDealerDataById(dealerId) {
        const url = `${getApiBaseUrl()}/api/Dealers/${dealerId}`;
        const data = await handleJsonRequest('GET', url, {});
        return data;
    }

}